import { render, staticRenderFns } from "./OuterView.vue?vue&type=template&id=5b6ae3bd&"
import script from "./OuterView.vue?vue&type=script&lang=js&"
export * from "./OuterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports